import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { ROL_PERFIL_ADMINISTRADOR } from '../constants/roles';

// Analogo a ModulosContext, pero para la plantilla de items de menu ocultos que el
// Administrador (rolId 1) define para los usuarios con Perfil Administrador (rolId 5)
// de su administradora. Solo se consulta cuando el usuario logueado es Perfil
// Administrador; para el resto de los roles no hay nada que filtrar.
export const PermisosMenuContext = createContext();

export const PermisosMenuProvider = ({ children }) => {
    const { administracionId, rolId } = useAuth();
    const [menuOcultos, setMenuOcultos] = useState([]);
    const [loadingPermisosMenu, setLoadingPermisosMenu] = useState(rolId === ROL_PERFIL_ADMINISTRADOR);

    useEffect(() => {
        if (rolId !== ROL_PERFIL_ADMINISTRADOR || !administracionId) {
            setMenuOcultos([]);
            setLoadingPermisosMenu(false);
            return;
        }

        const HOST_API = process.env.REACT_APP_URL;
        setLoadingPermisosMenu(true);
        axios.get(`${HOST_API}api/perfilAdminMenu/GetMenuOcultos`, { params: { administracionId } })
            .then(({ data }) => setMenuOcultos(data ?? []))
            .catch(() => setMenuOcultos([]))
            .finally(() => setLoadingPermisosMenu(false));
    }, [administracionId, rolId]);

    return (
        <PermisosMenuContext.Provider value={{ menuOcultos, loadingPermisosMenu }}>
            {children}
        </PermisosMenuContext.Provider>
    );
};

export const usePermisosMenu = () => useContext(PermisosMenuContext);
